import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

function App() {
  return (
    <LanguageProvider>
      <div className="grain min-h-screen bg-[#0B0A08] text-[#F7F4EE]">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-center" toastOptions={{ style: { background: "#1C1914", border: "1px solid rgba(197,160,89,0.35)", color: "#F7F4EE" } }} />
      </div>
    </LanguageProvider>
  );
}

export default App;
